<template>
  <a-drawer
    :maskClosable="false"
    width="35%"

    :visible="open"
    @close="
      onCloseConfirm(() => {
        open = false
      })
    "
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="材料名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="材料单位" prop="unitVal">
        <a-input v-model="form.unitVal" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>

      <a-form-model-item label="状态" prop="status">
        <a-radio-group button-style="solid" v-model="form.status">
          <a-radio-button :value="1"> 启用 </a-radio-button>
          <a-radio-button :value="0"> 禁用 </a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item label="材料图标" prop="icon">
        <file-upload
          type="image"
          :defaultList="form.icon ? [form.icon] : []"
          :file="form.icon"
          @input="getImg($event, 'icon')"
          :count="1"
          autoCropHeight="80"
          :isUpload="false"
          autoCropWidth="80"
        ></file-upload>
      </a-form-model-item>
      <a-form-model-item label="材料图片" prop="pic">
        <file-upload
          type="image"
          :defaultList="form.pic ? [form.pic] : []"
          :file="form.pic"
          @input="getImg($event, 'pic')"
          :count="1"
          autoCropHeight="80"
          :isUpload="false"
          autoCropWidth="80"
        ></file-upload>
      </a-form-model-item>
      <a-form-model-item label="参考价格说明" prop="sort">
        <a-input v-model="form.referenceData" placeholder="请输入" :maxLength="20" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-textarea v-model="form.remark" placeholder="请输入" :maxLength="150" />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { getObj, addObj, putObj } from '@/api/maintenance/materialitems/index.js'
import { fetchList } from '@/api/maintenance/catetory/index.js'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      cateList: [],
      submitLoading: false,
      data: [],
      formTitle: '',
      inputValue: '',
      inputValues: '',
      form: {
        id: undefined,
        name: undefined,
        pic: undefined,
        icon: undefined,
        remark: undefined,
        status: 1,
        sort: 99,
        referenceData: undefined,
        unitVal: undefined,
      },
      isShow: false,
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      inputVisible: false,
      inputVisibles: false,
      showLoading: false,
      loading: false,
      rules: {
        name: [{ required: true, message: '请输入的分类名称', trigger: 'blur' }],
        pic: [{ required: true, message: '请上传图片', trigger: 'blur' }],
        icon: [{ required: true, message: '请类目图片', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        unitVal: [{ required: true, message: '请选择单位', trigger: 'blur' }],

        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
    }
  },
  filters: {},
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    getCateList() {
      if (this.loading) return
      this.loading = true
      fetchList({})
        .then((res) => {
          this.cateList = res.data.records
          console.log(this.cateList)

          this.total = res.data.total
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          that.open = false
        },
        onCancel() {},
      })
    },
    getImg(info, fieldName) {
      this.form[fieldName] = info
      this.$refs.form.clearValidate(fieldName)
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    cancel() {
      this.onCloseConfirm(() => {
        this.open = false
      })
    },
    reset() {
      this.form = {
        id: undefined,
        name: undefined,
        pic: undefined,
        icon: undefined,
        remark: undefined,

        status: 1,
        sort: 99,
        referenceData: undefined,
        unitVal: undefined,
      }
      this.tags = []
      this.tagslist = []
    },
    handleAdd(e) {
      this.getCateList()
      this.reset()
      this.form.materialId = e
      this.open = true
      this.formTitle = '添加维修材料选项'
    },
    handleUpdate(row, ids) {
      this.getCateList()
      this.reset()
      const postId = row ? row.id : ids
      getObj(postId).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改维修材料选项'
      })
    },
    submitForm: function () {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          }
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
